import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Supplies the shipping-label page header with its scrolled state and back navigation. Registers a window scroll listener that is re-bound whenever isScroll changes, and exposes a handler navigating to `/rma/{rmaId}` from the route params.
 *
 * @returns The scrolled flag and the back navigation handler.
 */
const useShippingLabelHeader = () => {
  const { rmaId } = useParams();

  const navigate = useNavigate();

  const [isScroll, setIsScroll] = useState(false);

  /**
   * Leaves the shipping-label screen for the parent RMA detail page. Navigates to `/rma/{rmaId}` using rmaId from the route params.
   *
   * @returns Nothing.
   */
  const handlBackClick = () => {
    navigate(`/rma/${rmaId}`);
  };

  /**
   * Keeps the header's scrolled flag aligned with the window scroll offset. Sets isScroll false once window.scrollY is back at zero and true on the first non-zero offset, writing state only when the flag actually changes.
   *
   * @returns Nothing.
   */
  const handleScroll = () => {
    if (window.scrollY === 0 && isScroll) {
      setIsScroll(false);
    } else if (window.scrollY !== 0 && !isScroll) {
      setIsScroll(true);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isScroll]);

  return { isScroll, handlBackClick };
};

export { useShippingLabelHeader };
